// DS: P20
import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import FollowingWatchIcon from '@wix/da-ds/pkg/Icons/16x16/FollowingWatch';
import PremiumGalleryIcon from '@wix/da-ds/pkg/Icons/16x16/PremiumGallery';
import { normalizePremiumFolderData } from '../../utils/normalizePremiumFolderData';
import s from './FolderRibbon.scss';
const FolderRibbon = ({ premiumFolderData, className })=>{
    const { t } = useTranslation();
    const { isPremium, isPaidFolder, isWatchToAccess } = normalizePremiumFolderData(premiumFolderData);
    if (!isPremium) {
        return null;
    }
    let labelTransKey;
    if (isPaidFolder) {
        labelTransKey = 'folderCard.badge.premium';
    } else if (isWatchToAccess) {
        labelTransKey = 'folderCard.badge.watchers';
    } else {
        // we don't know what it is. if only we knew what it is... but we don't know.
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], isPaidFolder && s['premium'], isWatchToAccess && s['watchers'], className)
    }, isPaidFolder && /*#__PURE__*/ React.createElement(PremiumGalleryIcon, {
        className: s['icon']
    }), isWatchToAccess && /*#__PURE__*/ React.createElement(FollowingWatchIcon, {
        className: s['icon']
    }), /*#__PURE__*/ React.createElement("span", {
        className: s['title']
    }, t(labelTransKey)));
};
FolderRibbon.displayName = 'FolderRibbon';
export default FolderRibbon;

//# sourceMappingURL=FolderRibbon.js.map